import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class MerchantCenterGridBaseColumn extends ProjectionGridBaseColumn {
  constructor(options) {
    super(options);
    this.i18n = options.i18n;
    this.permissions = options.permissions;
  }

  // Override the default 'pickProperty' to pick multi properties.
  pickProperty(rowData) {
    return _.pick(rowData, this.property.key);
  }
}
